import { palette } from '../../foundations/__generated__/palette.js';

const linkThemeDefault = {
  link: {
    textPrimary: palette.brand[500],
    textPrimaryHover: palette.brand[500],
    textSecondary: palette.neutral[7],
    textSecondaryHover: palette.neutral[7]
  }
};
const linkThemeBrand = {
  link: {
    textPrimary: palette.neutral[100],
    textPrimaryHover: palette.neutral[100]
  }
};
const linkThemeBrandAlt = {
  link: {
    textPrimary: palette.neutral[7],
    textPrimaryHover: palette.neutral[7]
  }
};
const themeLink = {
  textPrimary: palette.brand[500],
  textPrimaryHover: palette.brand[500],
  textSecondary: palette.neutral[7],
  textSecondaryHover: palette.neutral[7]
};
const themeLinkBrand = {
  textPrimary: palette.neutral[100],
  textPrimaryHover: palette.neutral[100]
};
const themeLinkBrandAlt = {
  textPrimary: palette.neutral[7],
  textPrimaryHover: palette.neutral[7]
};

export { linkThemeBrand, linkThemeBrandAlt, linkThemeDefault, themeLink, themeLinkBrand, themeLinkBrandAlt };
